type BannerRuleSet = {
  max_width?: number;
  ratio?: string;
};

export type BannerSize = {
  width: number;
  height: number;
  /** CSS `aspect-ratio` değeri, ör. `2 / 1`. */
  aspectRatio: string;
};

/**
 * Banner ölçüsü şablonun `ruleSet`'inden gelir: genişlik `max_width`, yükseklik `max_width / ratio`.
 * Örn. `max_width: 384`, `ratio: "1/1"` -> 384 X 384. Değerlerden biri eksikse `null` döner.
 */
export const getBannerSize = (ruleSet?: BannerRuleSet): BannerSize | null => {
  const [ratioWidth, ratioHeight] = String(ruleSet?.ratio ?? '')
    .split('/')
    .map(Number);
  const width = Number(ruleSet?.max_width);

  if (!width || !ratioWidth || !ratioHeight) return null;

  return {
    width,
    height: Math.round((width * ratioHeight) / ratioWidth),
    aspectRatio: `${ratioWidth} / ${ratioHeight}`,
  };
};
